import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { poundsToKgs, kgsToPounds } from '../../helpers/utils';
import {
  saveBodyFat,
  clearBodyFatErrors,
} from '../../ducks/Measurements/actions';
import ProgressUpload from '../../components/ProgressUpload';
import { CLOSE_DRAWER } from '../../ducks/Global/constants';
import './index.css';
import moment from 'moment';
import { hasMinimumRole } from '../../utils/permissions';

class MeasurementForm extends React.Component {
  constructor() {
    super();
    this.state = {
      measurementObj: {},
      bodyFatObj: {},
      progressPictures: [],
    };
  }

  componentDidMount() {
    this.props.clearBodyFatErrors();
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.props.userBodyFatMeasurements.length !==
      nextProps.userBodyFatMeasurements.length
    ) {
      this.props.closeDrawer();
      this.setState({
        bodyFatObj: {},
        measurementObj: {},
        progressPictures: [],
      });

      // Same post-save redirect as the Manual form: drop the user on
      // the surface that displays the new entry.
      //   - Trainer logging for a client → that client's profile
      //     measurements tab (just a tab switch when they were
      //     already on the profile).
      //   - Self-log → /dashboard/stats/progress.
      const targetUserId = nextProps.data?.user?._id;
      const authedUserId = nextProps.user?._id;
      const isTrainerLogForOther =
        targetUserId &&
        authedUserId &&
        String(targetUserId) !== String(authedUserId);
      const dest = isTrainerLogForOther
        ? `/dashboard/admin/clients/${targetUserId}?tab=measurements`
        : '/dashboard/stats/progress';
      const here =
        (nextProps.history?.location?.pathname || '') +
        (nextProps.history?.location?.search || '');
      if (nextProps.history && here !== dest) {
        nextProps.history.push(dest);
      }
    }
  }

  renderBodyFatMeasurementForm = (data) => {
    const measurementOptionsFat = [
      {
        key: 'weight',
        label: 'Weight',
        gender: 'male',
        suffix: `${data.isMetric ? 'KG' : 'LB'}`,
      },
      {
        key: 'weight',
        label: 'Weight',
        gender: 'female',
        suffix: `${data.isMetric ? 'KG' : 'LB'}`,
      },
      { key: 'chest', area: 'chest', label: 'Chest', gender: 'male' },
      {
        key: 'abdominal',
        area: 'abdominal',
        label: 'Abdominal',
        gender: 'male',
      },
      { key: 'thigh', area: 'thigh', label: 'Thigh', gender: 'male' },
      { key: 'thigh', area: 'thigh', label: 'Thigh', gender: 'female' },
      { key: 'tricep', area: 'tricep', label: 'Tricep', gender: 'female' },
      {
        key: 'suprailiac',
        area: 'suprailiac',
        label: 'Suprailiac',
        gender: 'female',
      },
    ];
    const filteredOptions = measurementOptionsFat.filter(
      (option) => option.gender === data.gender
    );
    const saveErr =
      this.props.saveBodyFatError &&
      this.props.saveBodyFatError.type !== 'Manual' &&
      Array.isArray(this.props.saveBodyFatError.errors)
        ? this.props.saveBodyFatError.errors.map((e) => e.msg).filter(Boolean)
        : [];
    return (
      <div className="mf2">
        <div className="mf2-grid">
          {filteredOptions.map((option, i) => (
            <div className="mf2-field" key={`${option.key}-${i}`}>
              <label className="mf2-label">{option.label}</label>
              <div className="mf2-input-wrap">
                <input
                  type="number"
                  inputMode="decimal"
                  className="mf2-input"
                  value={this.state.measurementObj[option.key] ?? ''}
                  onChange={(e) =>
                    this.handleInputChange(e.target.value, option.key)
                  }
                  placeholder={option.suffix ? '0' : '0.0'}
                />
                <span className="mf2-input-suffix">
                  {(option.suffix || 'mm').toLowerCase()}
                </span>
              </div>
            </div>
          ))}
        </div>

        <div className="mf2-uploader">
          <ProgressUpload
            handler={this.handleImageInputChange}
            location="site"
            photos={this.state.progressPictures}
            clientId={this.props.data?.user?._id}
          />
        </div>

        {this.props.user &&
        hasMinimumRole(this.props.user.role, 'trainer') ? (
          <div className="mf2-field">
            <label className="mf2-label" htmlFor="mf2-date-3site">
              Date taken
            </label>
            <input
              id="mf2-date-3site"
              type="date"
              className="mf2-input"
              defaultValue={moment().format('YYYY-MM-DD')}
              onChange={this.onDateChange}
            />
          </div>
        ) : null}

        {saveErr.length > 0 ? (
          <div className="mf2-error" role="alert">
            {saveErr.map((m, i) => (
              <p key={i}>{m}</p>
            ))}
          </div>
        ) : null}
        {this.props.error ? (
          <div className="mf2-error" role="alert">
            <p>
              {this.props.error.status === 413
                ? 'Photos size limit is 50mb'
                : 'An error happened. Try again later'}
            </p>
          </div>
        ) : null}

        <div className="mf2-submit-row">
          <button
            type="button"
            className="btn btn-sm btn-ghost"
            onClick={() => this.setState({ measurementObj: {} })}
          >
            Reset
          </button>
          <button
            type="button"
            className="btn btn-grad mf2-submit"
            onClick={() => this.calculate()}
            disabled={this.props.saveBodyFatLoading}
          >
            {this.props.saveBodyFatLoading ? 'Calculating…' : 'Calculate'}
          </button>
        </div>
      </div>
    );
  };

  onDateChange = (e) => {
    const value = e.target.value;
    let measurementObj = { ...this.state.measurementObj };
    measurementObj.date = value ? new Date(value) : null;
    this.setState({ measurementObj });
  };

  handleInputChange = (value, key) => {
    let measurementObj = { ...this.state.measurementObj };
    measurementObj[key] = value;
    this.setState({ measurementObj: measurementObj });
  };

  handleImageInputChange = (value) => {
    this.setState({
      progressPictures: value,
    });
  };

  //calculate body fat and lean body mass
  calculate = () => {
    const { data, user } = this.props;
    let measurementObj = { ...this.state.measurementObj };
    if (data.gender === 'male') {
      let mmTotal =
        Number(measurementObj.chest) +
        Number(measurementObj.thigh) +
        Number(measurementObj.abdominal);
      // Body Density = 1.10938 – (0.0008267 x sum of skinfolds) + (0.0000016 x square of the sum of skinfolds) – (0.0002574 x age)
      let bodyDensity =
        1.10938 -
        0.0008267 * mmTotal +
        0.0000016 * mmTotal ** 2 -
        0.0002574 * data.age;
      // Body Fat Percentage (%) = (495 / Body Density) – 450
      let bfPercentage = (495 / bodyDensity - 450).toFixed(2);
      let leanBodyMass = (
        measurementObj.weight -
        (bfPercentage / 100) * measurementObj.weight
      ).toFixed(2);
      this.buildMeasurementObj(
        measurementObj,
        bfPercentage,
        leanBodyMass,
        data,
        user
      );
    } else if (data.gender === 'female') {
      let mmTotal =
        Number(measurementObj.tricep) +
        Number(measurementObj.thigh) +
        Number(measurementObj.suprailiac);
      // Body Density = 1.0994921 – (0.0009929 x sum of skinfolds) + (0.0000023 x square of the sum of skinfolds) – (0.0001392 x age)
      let bodyDensity =
        1.0994921 -
        0.0009929 * mmTotal +
        0.0000023 * mmTotal ** 2 -
        0.0001392 * data.age;
      // Body Fat Percentage (%) = (495 / Body Density) – 4.5 * 100;
      let bfPercentage = (495 / bodyDensity - 450).toFixed(2);
      let leanBodyMass = (
        measurementObj.weight -
        (bfPercentage / 100) * measurementObj.weight
      ).toFixed(2);
      this.buildMeasurementObj(
        measurementObj,
        bfPercentage,
        leanBodyMass,
        data,
        user
      );
    }
  };

  buildMeasurementObj = (
    measurementObj,
    bfPercentage,
    leanBodyMass,
    data,
    user
  ) => {
    let bodyFatObj = {};
    const base64images = [];
    bodyFatObj.userId = data.user._id;
    bodyFatObj.source = hasMinimumRole(user.role, 'trainer')
      ? 'Coach'
      : 'Manual Measurement';
    bodyFatObj.pictures = this.state.progressPictures;
    bodyFatObj.type = '3-Site Skinfold (Jackson & Pollock)';
    bodyFatObj.weight = {
      kg: data.isMetric
        ? measurementObj.weight
        : poundsToKgs(measurementObj.weight),
      lb: !data.isMetric
        ? measurementObj.weight
        : kgsToPounds(measurementObj.weight),
    };
    bodyFatObj.leanBodyMass = data.isMetric
      ? { kg: leanBodyMass, lb: kgsToPounds(leanBodyMass) }
      : { kg: poundsToKgs(leanBodyMass), lb: leanBodyMass };
    bodyFatObj.bfPercentage = bfPercentage;
    bodyFatObj.date = measurementObj.date;
    delete measurementObj.weight;
    bodyFatObj.measurements = measurementObj;
    this.setState({ bodyFatObj: bodyFatObj });
    this.props.saveBodyFat({
      bodyFatObj,
      progressPictures: this.state.progressPictures,
    });
  };

  render() {
    const { data, user } = this.props;
    return this.renderBodyFatMeasurementForm(data, user);
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    saveBodyFat: (obj) => dispatch(saveBodyFat(obj)),
    clearBodyFatErrors: () => dispatch(clearBodyFatErrors()),
    closeDrawer: () => {
      return dispatch({
        type: CLOSE_DRAWER,
      });
    },
  };
};

const mapStateToProps = (state) => {
  return {
    error: state.measurements.bodyFatError,
    saveBodyFatError: state.measurements.saveBodyFatError,
    saveBodyFatLoading: state.measurements.saveBodyFatLoading,
    userBodyFatMeasurements: state.measurements.userBodyFatMeasurements,
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(MeasurementForm)
);
